import { render, staticRenderFns } from "./limitDialog.vue?vue&type=template&id=023ebef5&"
import script from "./limitDialog.vue?vue&type=script&lang=js&"
export * from "./limitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports